var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3a13 13 0 1013 13A13.013 13.013 0 0016 3zm0 24a11 11 0 1111-11 11.012 11.012 0 01-11 11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25a9 9 0 100-18 9 9 0 000 18z"
  })));
}
export default SvgRecordFill;